import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useDispatch from 'client/hooks/useDispatch';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrUtilityProfitAdminRegisterAddressForm from 'client/components/SrUtilityProfitAdminRegisterAddressForm/SrUtilityProfitAdminRegisterAddressForm';

import './SrUtilityProfitNewAddressModal.less';

const BackToAutocompleteButton = ({ onClick }) => (
  <button type="button" styleName="backButton" onClick={onClick} aria-label="Back to autocomplete">
    <img styleName="backIcon" src="/images/arrow-left-grey-thick.svg" alt="" />
  </button>
);

const SrUtilityProfitNewAddressModal = ({
  onClose,
  onSuccessModalClose,
  afterSubmit,
  utilityPartnerId,
  utilityPartnerList,
}) => {
  const dispatch = useDispatch();
  const [isManualAddressEntry, setIsManualAddressEntry] = useState(false);

  const handleBackToAutocomplete = () => {
    setIsManualAddressEntry(false);
  };

  return (
    <SrDarkModal style={{ padding: '30px', alignItems: 'center' }}>
      <SrModalContent
        width={560}
        style={{ height: 'auto' }}
        innerStyle={{
          padding: '40px',
          width: '535px',
          boxShadow: '0px 15px 35px 0px #040F1D1A',
          borderRadius: '24px',
          border: '1px solid #E5E5E5',
          overflow: 'visible',
        }}
      >
        <div styleName="container">
          <div styleName="header">
            <div styleName="headerTitleBox">
              {isManualAddressEntry && (
                <BackToAutocompleteButton onClick={handleBackToAutocomplete} />
              )}
              <span styleName="headerTitle">Add New Address</span>
            </div>
            <button type="button" styleName="closeButton" onClick={onClose} aria-label="Close">
              <img styleName="closeIcon" src="/images/x-close-grey-medium.svg" alt="" />
            </button>
          </div>
          <div styleName="body">
            <SrUtilityProfitAdminRegisterAddressForm
              dispatch={dispatch}
              utilityPartnerId={utilityPartnerId}
              utilityPartnerList={utilityPartnerList}
              afterSubmit={afterSubmit}
              onSuccessModalClose={onSuccessModalClose}
              isManualAddressEntry={isManualAddressEntry}
              setIsManualAddressEntry={setIsManualAddressEntry}
            />
          </div>
        </div>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrUtilityProfitNewAddressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccessModalClose: PropTypes.func,
  afterSubmit: PropTypes.func,
  utilityPartnerId: PropTypes.number,
  utilityPartnerList: PropTypes.array,
};

BackToAutocompleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

SrUtilityProfitNewAddressModal.displayName = 'SrUtilityProfitNewAddressModal';

export default SrUtilityProfitNewAddressModal;
